import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import action from "../../assets/images/action.jpg";
import comedy from "../../assets/images/comedy.jpg";
import romance from "../../assets/images/romance.jpg";

const Genere = () => {
    return (
        <section className="genere-container">
            <ScrollContainer className="genere d-flex pl-2" horizontal={true}>
                <div className="genere-item"><img src={action} alt="" /></div>
                <div className="genere-item"><img src={comedy} alt="" /></div>
                <div className="genere-item"><img src={romance} alt="" /></div>
            </ScrollContainer>
        </section>
    );
};

export default Genere;
